import api from './axios';

/** Update an employee's joining date. Pass `null` (or '') to clear. HR-only on the backend. */
export function putJoiningDate(employeeUserId, joiningDate) {
  const payload = { joining_date: joiningDate == null || joiningDate === '' ? null : joiningDate };
  return api.put(`/users/${employeeUserId}/joining-date`, payload).then((r) => r.data);
}
